import { TypeAsnIncome } from '../../interfaces/Asn/TypeAsnIncome'
import { TypeAsnIncomeAction } from '../actions/typeAsnIncomeActions'
import { GET_TYPE_ASN_INCOME_EXITO } from '../types/typeAsnIncomeActionsTypes'

export interface TypeAsnIncomeState {
  typeAsnIncomeState: {
    typeAsnIncome?: TypeAsnIncome[]
    error?: string | undefined
  }
}

const initialState: TypeAsnIncomeState = {
  typeAsnIncomeState: { typeAsnIncome: [], error: '' }
}

export const typeAsnIncomeReducer = (
  state: TypeAsnIncomeState = initialState,
  action: TypeAsnIncomeAction
): TypeAsnIncomeState => {
  if (action.type === GET_TYPE_ASN_INCOME_EXITO) {
    return {
      ...state,
      typeAsnIncomeState: {
        typeAsnIncome: action.typeAsnIncome,
        error: action.error
      }
    }
  }
  return state
}
